import Output from "./components/Output.vue";

//Make these components have lazy loading
const Configurations  = resolve => {
  require.ensure(["./components/Configurations.vue"], () => {
    resolve(require("./components/Configurations.vue"));
  });
}
const Preview  = resolve => {
  require.ensure(["./components/Preview.vue"], () => {
    resolve(require("./components/Preview.vue"));
  });
}

export const routes = [
  { path: "", component: Output, name: "Output", meta: { keepAlive: false } },
  { path: "/configurations", alias:'/config', component: Configurations, name: "Configurations" , meta: { keepAlive: false } },
  { path: "/preview", component: Preview, name: "Preview", meta: { keepAlive: false } }

];
